module.exports = __webpack_public_path__ + "static/media/law-white.d75e7034.svg";